import { Dialog, Toolbar } from "client/Components";
import { navigateToWorkspace } from "client/Features/Workspace/routing";
import { localize } from "client_legacy/ndaw/culture";
import { reloadCurrentPage } from "client_legacy/ndaw/navigator";
import { ReactElement } from "react";

export const PageFailedDialog = (): ReactElement => (
	<Dialog
		trackingId="page-error-dialog"
	>
		<Dialog.Header title={localize("_FailedToLoadThePage")}/>
		<Dialog.Body>
			<p>{localize("_FailedToLoadThePageErrorText")}</p>
		</Dialog.Body>
		<Dialog.Footer>
			<Toolbar>
				<Toolbar.Button
					kind="secondary"
					onClick={() => navigateToWorkspace()}
					text={localize("_BackToWorkspace")}
					trackingId="back-to-workspace"
				/>
				<Toolbar.Button
					kind="primary"
					onClick={() => reloadCurrentPage()}
					text={localize("_Retry")}
					trackingId="confirm"
				/>
			</Toolbar>
		</Dialog.Footer>
	</Dialog>
);

PageFailedDialog.displayName = "PageFailedDialog";